/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./upsertStorage.defs.js";
export { main as default } from "./upsertStorage.defs.js";
